import React from 'react';

/**
 * Small animated stickman running toward the viewer (front view).
 * Legs: alternating knee-up / extended; arms: pump opposite to legs.
 */
const StickmanRunning = ({ className = 'h-5 w-5', ...props }) => (
  <svg
    viewBox="0 0 24 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* Head */}
    <circle cx="12" cy="5" r="3.5" />
    {/* Body */}
    <line x1="12" y1="8.5" x2="12" y2="16" />
    {/* Arms (shoulder 12,10) — pump: left back / right forward, then swap */}
    <g transform="translate(12, 10)">
      <g className="stickman-arm-left">
        <line x1="0" y1="0" x2="-6" y2="4" />
      </g>
    </g>
    <g transform="translate(12, 10)">
      <g className="stickman-arm-right">
        <line x1="0" y1="0" x2="6" y2="4" />
      </g>
    </g>
    {/* Legs (hip 12,16) — left knee up / right back, then swap */}
    <g transform="translate(12, 16)">
      <g className="stickman-leg-left">
        <line x1="0" y1="0" x2="-4" y2="10" />
      </g>
    </g>
    <g transform="translate(12, 16)">
      <g className="stickman-leg-right">
        <line x1="0" y1="0" x2="4" y2="10" />
      </g>
    </g>
  </svg>
);

export default StickmanRunning;
